import { createCachedSelector } from 're-reselect';
import { createSelector } from 'reselect';
import { State } from 'store/types';
import { UID } from 'types/types';
import { AsesState } from './types';

const selectAsesState = (state: State): AsesState => state.ases;

export const selectAsesListLoadStatus = createSelector(
  selectAsesState,
  (state) => state.listLoadStatus,
);

export const selectAsesListEverLoaded = createSelector(
  selectAsesState,
  (state): boolean => state.listLoadStatusEverLoaded,
);

export const selectAsesListPage = createSelector(
  selectAsesState,
  (state) => state.listPage,
);

export const selectAsesListFilterOptions = createSelector(
  selectAsesState,
  (state) => state.listFilterOptions,
);
export const selectAsesListFilterOptionsDraft = createSelector(
  selectAsesState,
  (state) => state.listFilterOptionsDraft,
);

export const selectAsesListFilterLoadStatus = createSelector(
  selectAsesState,
  (state) => state.listFilterLoadStatus,
);

export const selectAsesListFilterEverLoaded = createSelector(
  selectAsesState,
  (state) => state.listFilterLoadStatusEverLoaded,
);

export const selectAsesListFilter = createSelector(
  selectAsesState,
  (state) => state.listFilter,
);
export const selectAsesListFilterOrganisationIds = createSelector(
  selectAsesListFilter,
  (filter) => filter.organisationIds,
);
export const selectAsesListFilterDraft = createSelector(
  selectAsesState,
  (state) => state.listFilterDraft,
);

export const selectAsesListFilterSearchTerm = createSelector(
  selectAsesListFilter,
  (filter) => filter.searchTerm,
);

export const selectAsesListFilterStatuses = createSelector(
  selectAsesListFilter,
  (filter) => filter.statuses,
);

export const selectAsesListTotalCount = createSelector(
  selectAsesState,
  (state) => state.listTotalCount,
);

const selectAsesList = createSelector(selectAsesState, (state) => state.list);

export const selectAsesListIds = createSelector(selectAsesList, (list) =>
  Object.keys(list),
);

export const selectAsesListItem = createCachedSelector(
  selectAsesList,
  (_: State, assessmentId: UID) => assessmentId,
  (list, id) => list[id],
)((_, assessmentId: UID) => assessmentId);

const selectAsesListData = createSelector(
  selectAsesState,
  (state) => state.listData,
);

export const selectAsesListDataAssessmentStatuses = createSelector(
  selectAsesListData,
  (data) => data.assessmentStatuses,
);

const selectAsesOfflineAssessments = createSelector(
  selectAsesState,
  (state) => state.listOffline,
);

export const selectAsesOfflineAssessmentIds = createSelector(
  selectAsesOfflineAssessments,
  (offlineList) => Object.keys(offlineList),
);
